module.exports = {"id":"224458","name":"Diogo Jota","rating":"78","photo":"./data/images/photos/0/224458.png","club":{"name":"Wolverhampton","logo":"./data/images/clubs/Wolverhampton.png"},"positions":["AG","BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DiogoJota0.json
// module id = 1111
// module chunks = 0